// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"f6a61f34","310":"4200d522","395":"ed6957c4","437":"26f0305e","488":"7213179a","715":"070c6e00","795":"330d7ccd","836":"2bdc8a44","957":"f0406a30","963":"3799beaf"}[chunkId] + ".chunk.js";
};